import { getShopifyProducts, getStoreInfo, getShopifyCollections } from "../store/requests";
import { useQuery } from "@tanstack/react-query";
import { STORE, SHOPIFY_PRODUCTS, SHOPIFY_COLLECTIONS } from "./types";

export const useGetStoreInfo = () =>
  useQuery(STORE, () => getStoreInfo(), {
    // Store info rarely changes mid-session; avoid redundant /shop/ fetches
    // when multiple components (Sidebar MenuItem, useAccount, etc.) mount.
    // Mutations that change store state already call invalidateQueries(STORE).
    staleTime: 5 * 60 * 1000,
  });

export const useGetShopifyProducts = () =>
  useQuery(SHOPIFY_PRODUCTS, () => getShopifyProducts());

export const useShopifyCollections = () =>
  useQuery(SHOPIFY_COLLECTIONS, () => getShopifyCollections());
